import { useEffect, useRef, useState } from 'react';

import { isMotionReduced } from 'src/app/shared/utils/accessibility';

import { checkScrollVisibility, findScrollTargets } from '../../utils';

export function useShareFeed(intervalSeconds: number) {
	const [shouldAnimate, setShouldAnimate] = useState(() => !isMotionReduced());
	const scrollerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const scroller = scrollerRef.current;
		if (!(scroller && shouldAnimate)) {
			return undefined;
		}

		const handleInterval = () => {
			const { next, last } = findScrollTargets(scroller);

			if (last && checkScrollVisibility(scroller, last).right) {
				setShouldAnimate(false);
				return;
			}

			if (next) {
				scroller.scroll({
					left: next.offsetLeft,
				});
			}
		};

		const intervalId = setInterval(handleInterval, intervalSeconds * 1_000);

		return () => {
			clearInterval(intervalId);
		};
	}, [intervalSeconds, shouldAnimate]);

	return scrollerRef;
}
